/** @jsxImportSource @emotion/react */
import React, { Component } from 'react';
import Page from '@atlaskit/page';
import SideNavigation from "./components/SideNavigation";
import { Global, jsx, css } from '@emotion/react';
import { Content, LeftSidebar, Main, PageLayout } from '@atlaskit/page-layout';
import CssReset from '../../react-app/CssReset';

export default class App extends Component {

  render() {
    return (
      <div>
        <Page navigation={null}>
          {/*{CssReset}*/}
          <PageLayout >
            <Content >
              {this.props.showNavigation &&
              <LeftSidebar width={0}>
                <SideNavigation />
            </LeftSidebar>
              }
              <div css={css`flex: 1; & > div {overflow: initial}`}>
                <Main>
                  {this.props.children}
                </Main>
              </div>
          </Content>
        </PageLayout>
        </Page>
      </div>
    );
  }
}
